/* eslint-disable import/prefer-default-export */

export const CARD_TYPE = {
  QUIZ: 'quiz',
  POST: 'post'
};

export const CARD_STATE = {
  UPCOMING: 'UPCOMING',
  LIVE: 'LIVE',
  POST_LIVE: 'POST_LIVE'
};

export const STORE_FLAG = 'un_store';

export const CARD_WIDTH = '754px';

export const MODAL_TYPE = {
  REMOVE_SAVED_ITEM: 'REMOVE_SAVED_ITEM',
  FREE_PLAN_UNLOCK: 'FREE_PLAN_UNLOCK'
};

export const classIconColor = 'rgba(66, 94, 237, 1)';

export const SAVE_SAVE_CONTENT = 'Save - Save Content';
export const SAVE_UNSAVE_CONTENT = 'Save - Unsave Content';

export const UPCOMING_CLASS_ENABLE_THRESHOLD = 900;
